/**
 * Shared Base UI `Positioner` defaults for combobox, select, popover, menu.
 *
 * **`side: none`** (SideShiftMode): do **not** apply flip/shift on the main placement axis, so a
 * **`side="bottom"`** panel **stays below** the anchor instead of flipping above (matches the
 * product rule: options listed under the control, scroll to pick).
 *
 * **`align: shift`**: nudge horizontally if needed. **`fallbackAxisSide: none`**: no odd
 * perpendicular fallbacks.
 *
 * Pair with **`useVisualViewportCollisionRect`** for `collisionBoundary` so available height
 * respects the **visual viewport** (keyboard on iOS).
 */
export const anchoredPositionerCollisionAvoidance = {
  side: "none" as const,
  align: "shift" as const,
  fallbackAxisSide: "none" as const,
};

/** Padding from the collision boundary edges (safe area / margin). */
export const anchoredPositionerCollisionPadding = {
  top: 12,
  bottom: 12,
  left: 8,
  right: 8,
};

/**
 * Caps `--available-height` from Floating UI with a **minimum** height so iOS Safari does not
 * collapse the panel to a few pixels when the CSS variable is wrong vs the visual viewport.
 * Matches `max-h-72` (18rem) upper cap.
 */
export const anchoredPopoverMaxHeightClass =
  "max-h-[min(18rem,max(10rem,var(--available-height)))]";
